import { ref } from 'vue';
import ProtheusPresupuestoService from "@/services/ProtheusPresupuestoService.js";
import { Dialog, Notify } from 'quasar';

export function usePresupuestoHandler() {
    const exportLoading = ref(null);
    const exportar = async (id) => {
        exportLoading.value = id;
        try {
            const { data } = await ProtheusPresupuestoService.store(id);
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    Notify.create({
                        type: "positive",
                        message: `Presupuesto exportado con ID: ${v.idPresup} en ${k}`,
                        timeout: 0,
                        closeBtn: 'Cerrar',
                    });
                }
            }
        } catch (error) {
            Notify.create({
                type: "negative",
                message: "Error al exportar presupuesto",

            });
            console.error("Error storing presupuesto:", error);
        } finally {
            exportLoading.value = null;
        }
    };

    return {
        exportar,
        exportLoading
    };
}
